"use client";

import React, { useState } from "react";
import styled from "styled-components";
import Text from "../../Text";
import type { EditableCellType } from "./EditableTableCell";
import { filterCurrencyChars, commitCurrencyInput } from "./coerceValueForPaste";

const BulkInput = styled.input`
  flex: 1;
  font-size: inherit;
  line-height: 1.4;
  padding: 4px 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  color: #111;
`;

type Props = {
  type: EditableCellType;
  onCommit: (value: string) => void;
  currencySymbol?: string;
};

const BulkInputCell: React.FC<Props> = ({ type, onCommit, currencySymbol = "$" }) => {
  const [textValue, setTextValue] = useState(""),
    isCurrency = type === "currency",
    isNumeric = type === "number" || type === "percent" || isCurrency,
    inputType = isCurrency
      ? "text"
      : isNumeric
        ? "number"
        : type === "date" || type === "datetime-local"
          ? type
          : "text";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setTextValue(isCurrency ? filterCurrencyChars(e.target.value) : e.target.value);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onCommit(type === "currency" ? commitCurrencyInput(textValue) : textValue);
      setTextValue("");
    } else if (e.key === "Escape") {
      setTextValue("");
    }
  };

  return (
    <>
      {type === "currency" && (
        <Text
          style={{
            fontSize: "inherit",
            color: "#666",
            flexShrink: 0,
            pointerEvents: "none",
            userSelect: "none",
          }}>
          {currencySymbol}
        </Text>
      )}
      <BulkInput
        type={inputType}
        inputMode={type === "currency" ? "decimal" : undefined}
        value={textValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={type === "date" || type === "datetime-local" ? undefined : "Bulk edit…"}
      />
      {type === "percent" && (
        <Text style={{ fontSize: "inherit", color: "#666", flexShrink: 0 }}>%</Text>
      )}
    </>
  );
};

export default BulkInputCell;
